import { useContext } from 'react';
import { ThemeProvider, IconButton, Persona, PersonaSize } from '@fluentui/react';
import { useMsal } from '@azure/msal-react';
import { Theme } from '../../../theme/Theme';
import { useDarkMode } from '../../../theme';
import { AppContext } from '../../../providers/AppProvider';
import styles from './Navbar.module.css';

export default function Navbar() {
    const theme = Theme.get().navbar;
    const { instance, accounts } = useMsal();
    const account = accounts[0] || null;
    const appContext = useContext(AppContext);
    const { isDark, toggle: toggleDark } = useDarkMode();

    const iconBtnStyles = {
        root: { color: '#ffffff', width: 48, height: 48 },
        rootHovered: { color: '#ffffff', backgroundColor: 'rgba(255,255,255,0.1)' },
        rootPressed: { color: '#ffffff', backgroundColor: 'rgba(255,255,255,0.15)' },
        icon: { fontSize: 16 },
    };

    return (
        <ThemeProvider theme={theme}>
            <nav className={styles.root}>
                {/* Left: hamburger + app name */}
                <div className={styles.left}>
                    <a href="/" className={styles.logoLink}>
                        <img src="/images/agentbox-icon.svg" alt="AgentBox" className={styles.logo} />
                    </a>
                    <a href="/" className={styles.appName}>AgentBox</a>
                    <IconButton
                        iconProps={{ iconName: 'GlobalNavButton' }}
                        className={styles.menuBtn}
                        styles={iconBtnStyles}
                        ariaLabel="Toggle navigation"
                        onClick={() => appContext.setNavigationVisible(!appContext.navigationVisible)}
                    />
                </div>

                {/* Right: dark mode toggle + persona */}
                <div className={styles.right}>
                    <IconButton
                        iconProps={{ iconName: isDark ? 'Sunny' : 'ClearNight' }}
                        styles={iconBtnStyles}
                        ariaLabel={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
                        onClick={toggleDark}
                        title={isDark ? 'Light mode' : 'Dark mode'}
                    />
                    {account && (
                        <Persona
                            text={account.name || account.username}
                            size={PersonaSize.size28}
                            hidePersonaDetails
                            styles={{
                                root: {
                                    cursor: 'pointer',
                                    padding: '0 10px',
                                    height: 48,
                                    display: 'flex',
                                    alignItems: 'center',
                                    selectors: { ':hover': { backgroundColor: 'rgba(255,255,255,0.1)' } },
                                },
                            }}
                            coinProps={{
                                styles: {
                                    initials: { color: '#ffffff' },
                                },
                            }}
                            onClick={() => instance.logoutRedirect()}
                            title={`${account.name || account.username}\nClick to sign out`}
                        />
                    )}
                </div>
            </nav>
        </ThemeProvider>
    );
}
